


import React from 'react';
import { Box, Typography } from '@mui/material';
import { colorPrimary } from '../../Styles/Colors';
 
const CircularProgressIndicator = ({
  value = 50,
  variant = 'default', // 'default', 'dot', 'text'
  size = 48,
  color,
  ...props
}) => {
  const ringColor = color || colorPrimary;
  const thickness = 5;
  const bgColor = '#eee';
  const radius = (size - thickness) / 2;
  const circ = 2 * Math.PI * radius;
  const offset = circ - (value / 100) * circ;
  return (
    <Box sx={{ position: 'relative', width: size, height: size, display: 'inline-block' }} {...props}>
      <svg width={size} height={size}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={bgColor}
          strokeWidth={thickness}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={ringColor}
          strokeWidth={thickness}
          strokeDasharray={circ}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{ transition: 'stroke-dashoffset 0.5s' }}
        />
      </svg>
      {variant === 'dot' && (
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: size * 0.22,
            height: size * 0.22,
            borderRadius: '50%',
            background: ringColor,
          }}
        />
      )}
      {variant === 'text' && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="caption" sx={{ fontWeight: 600, fontSize: 12, color: ringColor }}>
            {`${value}%`}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default CircularProgressIndicator;
